<ng-container *ngIf="isInitForm">
    <!-- Просмотр фильтра -->
    <ng-container *ngIf="!formFilter.isOpenFilter && formFilter.isFilterSet">
        <div class="filled-filter" (click)="formFilter.isOpenFilter = true">
            <div class="filter-chips">
                <div
                    class="filter-shown-chips"
                    (click)="$event.stopPropagation()"
                    appOrganizeChips
                    (chipsHidden)="chipsHidden = $event"
                >
                    <ng-container *ngFor="let item of entityGrid">
                        <ng-container
                            *ngIf="
                                fieldGrid[item.name] &&
                                fieldGrid[item.name].length &&
                                isSubFormData(fieldGrid[item.name])
                            "
                        >
                            <ng-container *ngFor="let field of fieldGrid[item.name]">
                                <mat-chip-row *ngIf="isFieldData(formDynamic.get(field.name))">
                                    <!-- Выводим иконку связи если фильтр по связи -->
                                    <mat-icon
                                        class="link-icon"
                                        *ngIf="isCharacterInString(field.name, '|')"
                                        aria-hidden="true"
                                        fontSet="mdi"
                                        fontIcon="mdi-link-variant"
                                    >
                                    </mat-icon>
                                    <span class="filter-field-title"
                                        >{{ field.title[appService.currentLanguage] }}&nbsp;</span
                                    >
                                    {{ getValueItem(field, formDynamic) | truncate: 20 }}
                                    <fui-button
                                        matChipRemove
                                        class="ml-[8px]"
                                        (clickEvent)="clearField(formDynamic.get(field.name))"
                                        [title]="appService.language_dictionary.system_clear"
                                        borderRadius="circle"
                                        type="button-icon"
                                        icon="close"
                                        color="neutral"
                                        height="slim"
                                    >
                                    </fui-button>
                                </mat-chip-row>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="filter-more-chips">
                    <mat-chip-row class="more-chip" *ngIf="chipsHidden"> Еще: {{ chipsHidden }} </mat-chip-row>
                </div>
            </div>
            <div class="filter-panel" (click)="$event.stopPropagation()">
                <span class="filter-found">
                    {{ appService.language_dictionary.search_found }}: {{ formFilter.recordsFound }}
                </span>
                <fui-button
                    (clickEvent)="clickClear()"
                    [label]="appService.language_dictionary.system_drop_all"
                    height="slim"
                    color="soft-outline"
                    icon="close"
                >
                </fui-button>
            </div>
        </div>
    </ng-container>
    <!-- Форма фильтра -->
    <ng-container *ngIf="formFilter.isOpenFilter">
        <div class="filter-edit-form">
            <h3 class="form-filter-heading">
                {{ appService.language_dictionary.search_criterion }}
            </h3>
            <div class="form-filter mb-2">
                <ng-container *ngFor="let item of entityGrid">
                    <fui-card [ngStyle]="item.style">
                        <div class="form-filter-item" *ngIf="fieldGrid[item.name] && fieldGrid[item.name].length">
                            <div class="form-filter-item-title">{{ item.title[appService.currentLanguage] }}:</div>
                            <div class="form-filter-item-grid">
                                <ng-container *ngFor="let itemField of fieldGrid[item.name]">
                                    <div [ngStyle]="itemField.style">
                                        <ng-container
                                            [ngTemplateOutlet]="fieldTemplate"
                                            [ngTemplateOutletContext]="{ field: itemField, form: formDynamic }"
                                        >
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </fui-card>
                </ng-container>
            </div>
            <ng-container [ngTemplateOutlet]="filterAction"></ng-container>
        </div>
    </ng-container>
</ng-container>
<ng-template #filterAction>
    <div class="table-filter-container-button left-pager-button-container gap-x-[8px]">
        <fui-button
            (clickEvent)="clickSearch(!formFilter.isOpenFilter)"
            [label]="appService.language_dictionary.system_search"
            icon="magnify"
            color="soft"
            height="slim"
        >
        </fui-button>
        <fui-button
            (clickEvent)="clearCriteria()"
            [label]="appService.language_dictionary.search_clear_criteria"
            height="slim"
            color="soft-outline"
            icon="eraser"
        >
        </fui-button>
        <fui-button
            (clickEvent)="clickClear()"
            [label]="appService.language_dictionary.system_drop_all"
            height="slim"
            color="soft-outline"
            icon="close"
        >
        </fui-button>
        <fui-button
            [matMenuTriggerFor]="menuFilter"
            [title]="appService.language_dictionary.system_actions"
            height="slim"
            color="soft-outline"
            type="button-icon"
            icon="dots-vertical"
        >
        </fui-button>
        <mat-menu #menuFilter="matMenu">
            <button
                (click)="tableForm.saveFilter()"
                [disabled]="tableForm.selectFilter.type === 'default' || true"
                class="context-menu-item"
                type="button"
                mat-menu-item
            >
                <span>{{ appService.language_dictionary.system_setting_filter }}</span>
            </button>
            <button (click)="tableForm.openFilterDialog()" class="context-menu-item" type="button" mat-menu-item>
                <span>{{ appService.language_dictionary.system_save }}</span>
            </button>
            <ng-container
                *ngIf="
                    tableForm.settingsTable.isMap &&
                    tableService &&
                    tableService.saveAsLayer &&
                    appService.accessMatrix.map_admin.add === 1
                "
            >
                <button (click)="tableForm.openAddLayer()" class="context-menu-item" type="button" mat-menu-item>
                    <span>{{ appService.language_dictionary.system_save_layer }} </span>
                </button>
            </ng-container>
        </mat-menu>
    </div>
</ng-template>
<ng-template #fieldTemplate let-field="field" let-form="form">
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.registry">
        <ng-container
            dynamic-field
            [field]="{
                type: 'select-search',
                label: field.title[appService.currentLanguage],
                name: field.name,
                options: registers[field.filter.scope] ? registers[field.filter.scope] : [],
                multiple: true,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <!-- Базовый доступ -->
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.access">
        <!-- Субъект -->
        <ng-container
            dynamic-field
            [field]="{
                type: 'select-search',
                label:
                    field.title[appService.currentLanguage] +
                    ' (' +
                    appService.language_dictionary.system_subject +
                    ')',
                name: 'subject',
                options: registers['user_access_level_subject(' + field?.user_access_id + ')']
                    ? registers['user_access_level_subject(' + field?.user_access_id + ')']
                    : [],
                multiple: true,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form.get(field.name)"
        >
        </ng-container>

        <!-- Пользователь -->
        <ng-container *ngIf="field?.is_user_bind">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-search',
                    label:
                        field.title[appService.currentLanguage] +
                        ' (' +
                        appService.language_dictionary.system_user +
                        ')',
                    name: 'user',
                    options: registers['users'] ? registers['users'] : [],
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [group]="form.get(field.name)"
            >
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.technicalProcess">
        <ng-container *ngIf="!field?.filter?.list_view_as_tree">
            <div fxFlex="0 1 50%" fxFlex.md="0 1 25%" fxFlex.sm="100%" fxFlex.xs="100%" style="padding-right: 1%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'select-search',
                        label: field.title_tp[appService.currentLanguage],
                        name: 'tp',
                        options: field.filter.values_tp,
                        multiple: true,
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
            <div fxFlex="0 1 50%" fxFlex.md="0 1 25%" fxFlex.sm="100%" fxFlex.xs="100%" style="padding-left: 1%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'select-search',
                        label: field.title_regulation[appService.currentLanguage],
                        name: 'regulation',
                        options: field.filter.values_regulation,
                        multiple: true,
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.list">
        <ng-container *ngIf="!field?.filter?.list_view_as_tree">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-search',
                    label: field.title[appService.currentLanguage],
                    name: field.name,
                    options: field.filter.values,
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [group]="form"
            ></ng-container>
        </ng-container>
        <ng-container *ngIf="field?.filter?.list_view_as_tree">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-tree',
                    label: field.title[appService.currentLanguage],
                    name: field.name,
                    options: field.filter.values,
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [data]="{
                    isFolderSelect: true,
                    title: field.title[appService.currentLanguage],
                    treeData: field.filter.values ? field.filter.values : [],
                }"
                [group]="form"
            ></ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.string">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                mask: field.string_mask,
                regex: field.string_validation,
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.text">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.numerator">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.date">
        <div fxLayout="row wrap" fxLayoutAlign="flex-start" fxLayoutGap="2%">
            <div fxFlex="0 1 49%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: factorRowService.getDateType(field, dateFormat),
                        label:
                            field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_from,
                        name: 'from',
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                    [data]="{ maxField: 'to' }"
                ></ng-container>
            </div>
            <div fxFlex="0 1 49%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: factorRowService.getDateType(field, dateFormat),
                        label: field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_to,
                        name: 'to',
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                    [data]="{ minField: 'from' }"
                ></ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.digit">
        <div fxLayout="row wrap" fxLayoutAlign="flex-start" fxLayoutGap="2%">
            <div fxFlex="0 1 49%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'input',
                        label:
                            field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_from,
                        inputType: 'text',
                        name: 'from',
                        mask: 'integer',
                        validations: [
                            {
                                name: 'serverError',
                            },
                            {
                                name: 'max',
                                message: appService.language_dictionary.initial_value_cannot_greater_than_final,
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
            <div fxFlex="0 1 49%">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'input',
                        label: field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_to,
                        inputType: 'text',
                        name: 'to',
                        mask: 'integer',
                        validations: [
                            {
                                name: 'serverError',
                            },
                            {
                                name: 'min',
                                message: appService.language_dictionary.final_value_cannot_low_than_initial,
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.bool">
        <ng-container
            dynamic-field
            [field]="{
                type: 'select-search',
                label: field.title[appService.currentLanguage],
                name: field.name,
                options: [
                    { name: appService.language_dictionary.system_yes, id: 1 },
                    { name: appService.language_dictionary.system_no, id: 0 },
                ],
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.address">
        <fui-card [title]="field.title[appService.currentLanguage]">
            <div class="flex flex-col p-2 pt-0">
                <div>
                    <div [class.select-load-options]="isRegionLoaded">
                        <ng-container
                            [id]="field.name + '_region'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_region,
                                name: 'region',
                                options: addressData.region,
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isRegionLoaded"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div>
                    <div [class.select-load-options]="isLoadAddress.district[field.name]">
                        <ng-container
                            [id]="field.name + '_district'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_district,
                                name: 'district',
                                options: addressData?.district[field.name + '_district']
                                    ? addressData.district[field.name + '_district']
                                    : [],
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isLoadAddress.district[field.name]"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div>
                    <div [class.select-load-options]="isLoadAddress.city[field.name]">
                        <ng-container
                            [id]="field.name + '_city'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_city,
                                name: 'city',
                                options: addressData?.city[field.name + '_city']
                                    ? addressData.city[field.name + '_city']
                                    : [],
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isLoadAddress.city[field.name]"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="35"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div class="flex flex-col basis-full">
                    <div class="flex flex-row gap-[16px]">
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_1',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                    </div>
                    <div class="flex flex-row gap-[16px]">
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_2',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_3',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row gap-[16px]">
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.address_dialog_building,
                                inputType: 'text',
                                name: 'building',
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                    </div>
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.address_dialog_apartment,
                                inputType: 'text',
                                name: 'apartment',
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                </div>
                <div class="flex flex-row basis-full gap-[16px]">
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'checkbox',
                                label: appService.language_dictionary.system_including_additional_information,
                                name: 'including_additional_information',
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'checkbox',
                                label: appService.language_dictionary.system_exact_match,
                                name: 'exact_match',
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                </div>
            </div>
        </fui-card>
    </ng-container>
</ng-template>
